import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import Multiselect from "../multiselect";

import { getAllAvailableWeekDays } from "@/plugins/schedules_helper";

@Component({ components: { Multiselect }, methods: { moment } })
export default class DeliveryDayMultiselect extends Vue {
  @Prop({ default: null }) selectedDeliveryDay;
  @Prop({ default: null }) currentCityZone;

  availableWeekDays = [];

  get getSelectedDeliveryDay() {
    return getAllAvailableWeekDays().find(
      (day) => day.creation_week_day === this.selectedDeliveryDay.creation_week_day
    );
  }

  mounted() {
    this.setAvailableWeekDays();
  }

  @Watch("currentCityZone")
  onCurrentCityZoneChange() {
    this.setAvailableWeekDays();
  }

  setAvailableWeekDays() {
    this.availableWeekDays = [];
    const { weekdays } = this.currentCityZone.delivery_schedule;
    getAllAvailableWeekDays().forEach((availableWeekDay) => {
      if (weekdays.find((dayNumber) => dayNumber == availableWeekDay.creation_week_day)) {
        this.availableWeekDays.push(availableWeekDay);
      }
    });
  }
}
